import type { AdminCapability, AdminRole } from "@utopia-well-done-ltd/contracts";

/**
 * The role matrix, mirrored from the backend (D-063 §4).
 *
 * This hides what a role cannot do. It does not authorise anything: the server refuses the request
 * regardless, and a panel that trusted this table would be a panel one edited bundle away from
 * having no authorization at all. Hiding a button is a courtesy to the operator, nothing more.
 */
const ROLE_CAPABILITIES: Record<AdminRole, readonly AdminCapability[]> = {
  admin: [
    "players.read",
    "players.sessions.read",
    "players.sessions.revoke",
    "players.status.write",
    "games.read",
    "games.lifecycle.write",
    "rg.read",
    "rg.write",
    "kyc.review",
    "cases.read",
    "cases.write",
    "ledger.read",
    "reports.financial.read",
    "wallet.adjust.approve",
    "wallet.reversal.approve",
    "flags.write",
    "audit.read",
    "admins.initiate",
    "royal_spin.campaign.approve",
    "royal_spin.campaign.read",
    "royal_spin.emergency.write",
  ],
  finance: [
    "players.read",
    "games.read",
    "rg.read",
    "ledger.read",
    "reports.financial.read",
    "wallet.adjust.initiate",
    "wallet.reversal.initiate",
    "audit.read",
    "royal_spin.campaign.initiate",
    "royal_spin.campaign.read",
  ],
  kyc_officer: ["players.read", "games.read", "rg.read", "kyc.review", "cases.read", "cases.write"],
  super_admin: [
    "players.read",
    "players.sessions.read",
    "players.sessions.revoke",
    "players.status.write",
    "games.read",
    "games.config.activate",
    "games.lifecycle.write",
    "rg.read",
    "rg.write",
    "kyc.review",
    "cases.read",
    "cases.write",
    "ledger.read",
    "reports.financial.read",
    "wallet.adjust.approve",
    "wallet.reversal.approve",
    "flags.write",
    "audit.read",
    "admins.approve",
    "royal_spin.campaign.approve",
    "royal_spin.campaign.read",
    "royal_spin.emergency.write",
  ],
  support: [
    "players.read",
    "players.sessions.read",
    "players.sessions.revoke",
    "players.status.write",
    "games.read",
    "rg.read",
    "cases.read",
    "cases.write",
    "ledger.read",
  ],
};

export function can(role: AdminRole, capability: AdminCapability): boolean {
  return ROLE_CAPABILITIES[role].includes(capability);
}
